import {create} from 'zustand';

type MadeToOrderStore = {
  isOpen: boolean;
  toggleOpen: () => void;
  handleClose: () => void;
  productTitle: string;
  setProductTitle: (text: string) => void;
  fullName: string;
  setFullName: (text: string) => void;
  email: string;
  setEmail: (text: string) => void;
  chest: string;
  setChest: (number: number) => void;
  waist: string;
  setWaist: (number: number) => void;
  hips: string;
  setHips: (number: number) => void;
  fabric: string;
  setFabric: (text: string) => void;
  request: string;
  setRequest: (text: string) => void;
};

export const useMadeToOrderStore = create<MadeToOrderStore>((set) => ({
  isOpen: false,
  toggleOpen: () => set((state) => ({isOpen: !state.isOpen})),
  handleClose: () => set(() => ({isOpen: false})),

  productTitle: '',
  setProductTitle: (text: string) => set(() => ({productTitle: text})),

  fullName: '',
  setFullName: (text: string) => set(() => ({fullName: text})),
  email: '',
  setEmail: (text: string) => set(() => ({email: text})),

  chest: '',
  setChest: (number: number) => set(() => ({chest: number.toString()})),
  waist: '',
  setWaist: (number: number) => set(() => ({waist: number.toString()})),
  hips: '',
  setHips: (number: number) => set(() => ({hips: number.toString()})),

  fabric: '',
  setFabric: (text: string) => set(() => ({fabric: text})),
  request: '',
  setRequest: (text: string) => set(() => ({request: text})),
}));
